import type { ItemListItem } from '@/types';
import { ItemCard } from './ItemCard';

interface ItemGridProps {
  items: ItemListItem[];
  onItemClick: (item: ItemListItem) => void;
}

export function ItemGrid({ items, onItemClick }: ItemGridProps) {
  return (
    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-ai-id="item-grid">
      {items.map((item) => (
        <ItemCard key={item.id} item={item} onClick={() => onItemClick(item)} />
      ))}
    </div>
  );
}
